module.exports = __webpack_public_path__ + "img/img_footer_tree2.702b9195.png";